export enum MessageStatus {
  Received = 'received',
  Sent = 'sent',
  DeliverySucceeded = 'delivery:succeeded',
  DeliveryFailed = 'delivery:failed',
  Read = 'read',
}
